import { EducatorUserService, ServiceStatusEnum } from "@imaginelearning/mps-api-service";

function sendDataToPendo(data: any, productsLicensed: string[] = []) {
  const pendoPayload = transformResponseDataIntoPendoPayload(data);
  const { organizationDetails, siteOrganizationDetails, userGuid } = pendoPayload;

  if (window.pendo?.initialize) {
    const payload = {
      visitor: {
        id: userGuid,
        role: pendoPayload.roleName,
        grade: pendoPayload.gradeLevel,
        productsLicensed
      },
      account: {
        id: organizationDetails.institutionId,
        institutionName: organizationDetails.institutionName,
        institutionALAID: organizationDetails.institutionId,
        institutionState: organizationDetails.institutionState,
        institutionCategory: organizationDetails.institutionCategory,
        institutionALAType: organizationDetails.institutionAlaType,
        siteInstitutionname: siteOrganizationDetails.siteInstitutionName,
        siteInstitutionALAID: siteOrganizationDetails.siteInstitutionId,
        siteInstitutionLoginCode: siteOrganizationDetails.siteCode,
        siteInstitutionState: siteOrganizationDetails.siteInstitutionState,
        siteInstitutionCategory: siteOrganizationDetails.siteInstitutionOrgType,
        siteInstitutionALAType: siteOrganizationDetails.siteInstitutionAlaType
      }
    };

    window.pendo.initialize(payload);
  }
}

function transformResponseDataIntoPendoPayload(data: any) {
  const Studentdata = data;

  const institutionName: string[] = [];
  const institutionId: number[] = [];
  const institutionState: string[] = [];
  const institutionOrgType: string[] = [];
  const institutionAlaType: string[] = [];
  const institutionAlaGuid: string[] = [];

  Studentdata.organizationDetails.forEach((row: any) => {
    institutionName.push(row.institutionName);
    institutionId.push(row.institutionId);
    institutionState.push(row.institutionState);
    institutionOrgType.push(row.institutionOrgType);
    institutionAlaType.push(row.institutionAlaType);
    institutionAlaGuid.push(row.institutionGuid);
  });

  const studentMetadata = {
    ...Studentdata,
    organizationDetails: {
      institutionName: institutionName.join(""),
      institutionId: institutionId.join(""),
      institutionState: institutionState.join(""),
      institutionCategory: institutionOrgType.join(""),
      institutionAlaType: institutionAlaType.join(""),
      institutionAlaGUID: institutionAlaGuid[0]
    }
  };

  return studentMetadata;
}

export default function usePendo() {
  const initialize = async (userGuid: string, productsLicensed: string[]) => {
    const { status, data } = await EducatorUserService.getPendoMetadata(userGuid);
    if (status === ServiceStatusEnum.LOADED) {
      sendDataToPendo(data, productsLicensed);
    }
  };

  return { initialize };
}
